import { render, staticRenderFns } from "./FamilyDiscModal.vue?vue&type=template&id=ec373d10&scoped=true"
import script from "./FamilyDiscModal.vue?vue&type=script&lang=js"
export * from "./FamilyDiscModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec373d10",
  null
  
)

export default component.exports